import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass({
          'form-element-type': true,
          'active-type': true,
        })
}
const _hoisted_3 = { class: "grid" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 1,
  class: "col"
}
const _hoisted_6 = {
  key: 2,
  class: "col"
}
const _hoisted_7 = { class: "col radio" }
const _hoisted_8 = {
  key: 3,
  class: "col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Card = _resolveComponent("Card")!
  const _component_FormInput = _resolveComponent("FormInput")!
  const _component_image_selector = _resolveComponent("image-selector")!
  const _component_Radio = _resolveComponent("Radio")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.editing)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formQuestionTypes, (question, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass({
          'form-element-type': true,
          'active-type': question.type === _ctx.model.questionType,
        }),
                onClick: ($event: any) => (_ctx.changeQuestionType(question.type))
              }, [
                _createVNode(_component_font_awesome_icon, {
                  icon: _ctx.getIcon(question.type),
                  class: "type-icon"
                }, null, 8, ["icon"]),
                _createVNode(_component_TranslatedText, {
                  path: `form.fields.${question.type}`,
                  class: "type-text"
                }, null, 8, ["path"])
              ], 10, _hoisted_1))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.editing)
      ? (_openBlock(), _createBlock(_component_Card, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_font_awesome_icon, {
                icon: _ctx.getIcon(_ctx.model.questionType),
                class: "type-icon"
              }, null, 8, ["icon"]),
              _createVNode(_component_TranslatedText, {
                path: `form.fields.${_ctx.model.questionType}`,
                class: "type-text"
              }, null, 8, ["path"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _cache[11] || (_cache[11] = _createElementVNode("hr", null, null, -1)),
    _createVNode(_component_Form, {
      modelValue: _ctx.model,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model) = $event)),
      schema: {}
    }, {
      default: _withCtx(({ handleInputChange }) => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormInput, {
              value: _ctx.model.text,
              error: '',
              onChange: handleInputChange,
              label: "form.label",
              name: "text",
              id: "text"
            }, null, 8, ["value", "onChange"])
          ]),
          (
              ['statements', 'checkboxes', 'select'].includes(
                _ctx.model.questionType
              )
            )
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "col add-choice",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addChoice && _ctx.addChoice(...args)))
              }, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("p", null, [
                  _createElementVNode("span", { class: "add-sign" }, "+"),
                  _createTextVNode(" Add New Choice")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (
              ['statements', 'checkboxes', 'select'].includes(
                _ctx.model.questionType
              ) && _ctx.model.choices?.length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Choices", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.choices, (choice, choiceIndex) => {
                  return (_openBlock(), _createBlock(_component_FormInput, {
                    key: choice.id,
                    value: choice.data,
                    error: '',
                    onChange: ({ value }) => (_ctx.model.choices[choiceIndex].data = value),
                    label: 'Choice ' + (choiceIndex + 1),
                    name: 'choice' + choiceIndex,
                    id: 'choice' + choiceIndex
                  }, null, 8, ["value", "onChange", "label", "name", "id"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.model.questionType === 'image')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
                _createVNode(_component_image_selector, {
                  type: "image",
                  placeholderImage: _ctx.model.imageUrl,
                  previewStyle: {
                backgroundImage: `url('${_ctx.model.imageUrl}')`,
              },
                  onChange: _ctx.setImage
                }, null, 8, ["placeholderImage", "previewStyle", "onChange"])
              ]))
            : _createCommentVNode("", true),
          _cache[10] || (_cache[10] = _createElementVNode("p", { class: "col" }, "Validation Required?", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_Radio, {
              value: 'yes',
              modelValue: _ctx.model.validationNeeded,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.validationNeeded) = $event)),
              id: "validation-yes",
              text: "references.yes",
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.model.validationNeeded = 'yes'))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_Radio, {
              value: 'no',
              modelValue: _ctx.model.validationNeeded,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.validationNeeded) = $event)),
              id: "validation-no",
              text: "references.no",
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.model.validationNeeded = 'no'))
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.model.validationNeeded === 'yes')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_MultiSelect, {
                  value: _ctx.model.selectedValidation,
                  label: "form.validators",
                  name: "validators",
                  id: "validators",
                  items: _ctx.validationTypes[_ctx.model.questionType],
                  onChange: _cache[5] || (_cache[5] = 
                (selected) => (_ctx.model.selectedValidation = selected.value)
              )
                }, null, 8, ["value", "items"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}